import { get, post } from '@/request/request'

export default {
    list(params) {
        return get('/admin/communication/list', params)
    },
    save(params) {
        return post('/admin/communication/save', params)
    },
    delete(params) {
        return post('/admin/communication/delete', params)
    }

}